import { render, staticRenderFns } from "./feeitemsetpreferent.vue?vue&type=template&id=fad79f6e&scoped=true&"
import script from "./feeitemsetpreferent.vue?vue&type=script&lang=js&"
export * from "./feeitemsetpreferent.vue?vue&type=script&lang=js&"
import style0 from "./feeitemsetpreferent.vue?vue&type=style&index=0&id=fad79f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad79f6e",
  null
  
)

export default component.exports